import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  List,
  Search,
  HighlightOffOutlined,
  Add,
  Link,
  Close,
  InsertCommentOutlined,
  OpenInNewOutlined,
  AutorenewOutlined,
} from "@mui/icons-material";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import clsx from "clsx";
import {
  Grid,
  Tooltip,
  Box,
  Alert,
  Card,
  TextField,
  Stack,
  Snackbar,
  ClickAwayListener,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  Slide,
} from "@mui/material";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import Moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

import NewLinkPaymentsAdmin from "views/Dialog/NewLinkPaymentsAdmin";
import ViewsTrasactionsPayment from "views/Dialog/ViewsTrasactionsPayment";
import StatusPaymentLinkAdmin from "views/Dialog/StatusPaymentLinkAdmin";
import ViewLinkAdmin from "views/Dialog/ViewLinkAdmin";
import StatusRefundLinkAdmin from "views/Dialog/StatusRefundLinkAdmin";

import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  AntSwitch,
  ButtonStyle0,
  ButtonTableGrid2,
  ButtonTableGrid1,
  blackColor,
  ButtonExit,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function PaymentsListAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openWithdrawPayment, setOpenWithdrawPayment] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [totalBalance, setTotalBalance] = useState("0.00");
  const [totalOutstandingBalance, setTotalOutstandingBalance] =
    useState("0.00");
  const [totalTransitBalance, setTotalTransitBalance] = useState("0.00");
  const [mensageSystem, setMensageSystem] = useState("");
  const [openSnackbar, setOpenSnackbar] = React.useState({
    mensage: "",
    open: false,
  });
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [dateStart, setDateStart] = useState(false);
  const [dateEnd, setDateEnd] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [openRefund, setOpenRefund] = useState(false);
  const [openMessageNotification, setOpenMessageNotification] = useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  let resultSearch = "";

  const { urlServices, UserAuth, urlWeb } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    endLink: null,
    startLink: null,
  });

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "reference",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 12, color: blackColor }}
              >{`${params.row.reference}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Cliente",
        field: "name",
        // headerAlign: "center",
        width: 300,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "3px", // Espacio opcional entre los elementos
                margin: "8px 0",
              }}
            >
              <div
                style={{ fontSize: 14, color: blackColor, fontWeight: "bold" }}
              >
                {`${params.row?.name} ${params.row.lastName}`}
              </div>
              <div style={{ fontSize: 10, color: "#333" }}>
                <b>Documento ID:</b> {`${params.row?.documentId}`}
              </div>
              <div style={{ fontSize: 10, color: "#333" }}>
                <b>Email:</b> {`${params.row?.email}`}
              </div>
            </div>
          );
        },
      },
      {
        headerName: "Descripción",
        field: "description",
        headerAlign: "center",
        width: 250,
        // align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 14 }}
              >{`${params.row.description}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Total",
        field: "commissionPayment",
        headerAlign: "center",
        width: 110,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "3px", // Espacio opcional entre los elementos
                margin: "8px 0",
              }}
            >
              <div style={{ fontSize: 14, color: "green", fontWeight: "bold" }}>
                {`$${params.row?.commissionPaymentTotal}`}
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "rgb(95, 33, 32)",
                  background: "rgb(253, 237, 237)",
                  padding: 2,
                  borderRadius: 4,
                }}
              >
                <b>FEE:</b> {`$${params.row?.commissionPayment}`}
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "#4a4848ff",
                  fontWeight: "bold",
                  background: "#F1F1F1",
                  padding: 2,
                  borderRadius: 4,
                }}
              >
                <b>Total:</b>{" "}
                {`$${(parseFloat(params.row?.commissionPayment) + parseFloat(params.row?.commissionPaymentTotal)).toFixed(2)}`}
              </div>
            </div>
          );
        },
      },
      {
        headerName: "---",
        field: "slug",
        headerClassName: "super-app-theme--header",
        width: 120,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Grid
              container
              sx={{
                display: parseInt(params.row.status) === 2 ? "none" : "block",
              }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display:
                    parseInt(params.row.status) === 3 ||
                    parseInt(params.row.status) === 4
                      ? "none"
                      : "block",
                }}
              >
                <CopyToClipboard
                  text={`${urlWeb}payment/${params.value}`}
                  onCopy={handleCopy}
                >
                  <ButtonTableGrid2
                    startIcon={<Link sx={{ fontSize: 18 }} />}
                    style={{
                      margin: "12px 0 1px 0",
                      padding: "4px 8px",
                      width: "100%",
                    }}
                  >
                    Copiar link
                  </ButtonTableGrid2>
                </CopyToClipboard>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display:
                    parseInt(params.row.status) === 3 ||
                    parseInt(params.row.status) === 4
                      ? "none"
                      : "block",
                }}
              >
                <ButtonTableGrid2
                  startIcon={<OpenInNewOutlined sx={{ fontSize: 18 }} />}
                  style={{
                    marginTop: 3,
                    padding: "4px 8px",
                    width: "100%",
                    background: "green",
                    color: "#fff",
                  }}
                  onClick={() =>
                    window.open(`${urlWeb}payment/${params.value}`, "_blank")
                  }
                >
                  Abrir link
                </ButtonTableGrid2>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display:
                    params.row.paymentTransactions?.length > 0
                      ? "block"
                      : "none",
                }}
              >
                <ButtonTableGrid1
                  onClick={handleDetails(params)}
                  style={{
                    margin: "5px 0",
                    fontSize: 10,
                    width: "100%",
                    padding: "6px 8px",
                  }}
                >
                  Ver transacción
                </ButtonTableGrid1>
              </Grid>
            </Grid>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Estado link",
        field: "status",
        headerAlign: "center",
        width: 130,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text =
            params.value === 1
              ? "ACTIVO"
              : params.value === 99
                ? "DESHABILITADO"
                : params.value === 3
                  ? "PAGADO"
                  : params.value === 4
                    ? "REEMBOLSO"
                    : "CADUCADO";
          const color =
            params.value === 3
              ? "success"
              : params.value === 99 || params.value === 1
                ? "warning"
                : params.value === 4
                  ? "info"
                  : "error";

          let refunds =
            params.value === 4
              ? params.row?.refunds
                ? JSON.parse(params.row?.refunds)
                : null
              : null;
          return (
            <Alert
              severity={color}
              icon={false}
              sx={{
                width: "100%", // Ocupa el 100%
                py: 1, // Ajusta el padding vertical para compactar
                px: 1, // Ajusta el padding horizontal
                display: "flex",
                justifyContent: "center", // Centra horizontalmente
                alignItems: "center", // Centra verticalmente (opcional)
                "& .MuiAlert-message": {
                  padding: 0, // Elimina el padding interno del mensaje
                  width: "100%", // Forzar ancho completo
                  textAlign: "center", // Centra el texto
                },
                // background: text === "PAGADO" ? "#fff" : "",
              }}
            >
              <b style={{ color: color, fontSize: 12 }}>
                {text}
                <br></br>
                <Box
                  sx={{
                    fontSize: 8,
                    display: text === "ACTIVO" ? "block" : "none",
                  }}
                >
                  Hasta: {Moment(params.row.endExpiration).format("DD-MM-YYYY")}
                </Box>
                <Box
                  sx={{
                    fontSize: 8,
                    display: text === "PAGADO" ? "block" : "none",
                  }}
                >
                  (Cliente pago)
                </Box>
                <Box
                  sx={{
                    fontSize: 11,
                    display: text === "REEMBOLSO" ? "block" : "none",
                  }}
                >
                  {refunds ? (
                    refunds?.admin ? (
                      <b style={{ color: "green" }}>REALIZADO</b>
                    ) : (
                      <b style={{ color: "red" }}>PENDIENTE</b>
                    )
                  ) : (
                    <b style={{ color: "red" }}>PENDIENTE</b>
                  )}
                </Box>
              </b>
            </Alert>
          );
        },
      },
      {
        headerName: "Retirar",
        field: "startExpiration",
        headerClassName: "super-app-theme--header",
        width: 110,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Box
              sx={{
                display:
                  parseInt(params.row.status) === 1 ||
                  parseInt(params.row.status) === 2 ||
                  parseInt(params.row.status) === 4
                    ? "none"
                    : parseInt(params.row.transitBalance) === 1
                      ? "block"
                      : "none",
              }}
            >
              {parseInt(params.row.withdrawPayment) === 0 && (
                <ButtonTableGrid1
                  onClick={handleWithdrawPaymentValue(params)}
                  style={{
                    margin: "5px 0",
                    fontSize: 10,
                    width: "100%",
                    background: "orange",
                    padding: "6px 8px",
                  }}
                >
                  Recibir pago
                </ButtonTableGrid1>
              )}

              {parseInt(params.row.withdrawPayment) === 1 &&
                !params.row?.notification && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 10,
                      fontWeight: "bold",
                      color: "rgb(102, 60, 0)",
                      background: "rgb(255, 244, 229)",
                      py: 1,
                    }}
                  >
                    SOLICITUD ENVIADA{" "}
                    <span style={{ fontSize: 8 }}>(Recibir pago)</span>
                  </Box>
                )}

              {parseInt(params.row.withdrawPayment) === 1 &&
                params.row?.notification && (
                  <ButtonTableGrid1
                    onClick={handleMessageNotificationValue(params)}
                    style={{
                      margin: "5px 0",
                      fontSize: 10,
                      width: "100%",
                      background: "red",
                      padding: "6px 8px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span>MENSAJE</span>
                    <span style={{ fontSize: 8 }}>(Administración)</span>
                  </ButtonTableGrid1>
                )}
            </Box>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>
              {params.value
                ? Moment(params.value).format("DD-MM-YYYY")
                : ""}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 100,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 130,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Ver registro" arrow>
                  <Search style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Ver registro"
              onClick={openViewValue(params)}
            />,
          );

          if (parseInt(params.row.status) === 99) {
            // Si el perfil está deshabilitado, mostramos el icono para habilitarlo
            actions.push(
              /* <GridActionsCellItem
                      key="enable"
                      icon={
                        <Tooltip title="Habilitar" arrow>
                          <AddCircle style={{ fontSize: 24, color: "green" }} />
                        </Tooltip>
                      }
                      label="Habilitar"
                      onClick={openStatusValue(params)}
                    />*/
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                style={{
                  marginLeft: "-9px",
                  display:
                    parseInt(params.row.status) === 2 ||
                    parseInt(params.row.status) === 3 ||
                    parseInt(params.row.status) === 4
                      ? "none"
                      : "block",
                }}
              >
                <Tooltip title="Habilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 99 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params, 1)}
                  />
                </Tooltip>
              </Stack>,
            );
          } else {
            // Si el perfil está habilitado, mostramos el icono para deshabilitarlo
            actions.push(
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                style={{
                  marginLeft: "-9px",
                  display:
                    parseInt(params.row.status) === 2 ||
                    parseInt(params.row.status) === 3 ||
                    parseInt(params.row.status) === 4
                      ? "none"
                      : "block",
                }}
              >
                <Tooltip title="Deshabilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 99 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params, 99)}
                  />
                </Tooltip>
              </Stack>,
            );
          }

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Eliminar" arrow>
                  <HighlightOffOutlined
                    style={{ fontSize: 24, color: "red" }}
                  />
                </Tooltip>
              }
              style={{
                display:
                  parseInt(params.row.status) === 3 ||
                  parseInt(params.row.status) === 4
                    ? "none"
                    : "block",
              }}
              label="Eliminar"
              onClick={openStatusValue(params, 0)}
            />,
          );

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Reembolso" arrow>
                  <AutorenewOutlined
                    style={{ fontSize: 24, color: "orange" }}
                  />
                </Tooltip>
              }
              style={{
                display: parseInt(params.row.status) === 3 ? "block" : "none",
              }}
              label="Reembolso"
              onClick={openRefundValue(params, 0)}
            />,
          );
          return actions;
        },
      },
    ],
  });

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleCopy = () => {
    setOpenSnackbar({ mensage: "Link copiado al portapapeles!", open: true });
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchText(searchValue);

    if (searchValue.trim() !== "") {
      const searchLower = removeAccents(searchValue.toLowerCase());

      resultSearch = rows.filter((item) => {
        // Búsqueda por nombre de proveedor
        const nameMatch = removeAccents(item.name.toLowerCase() || "").includes(
          searchLower,
        );

        // Búsqueda por nombre de aplicación
        const lastNameMatch = item.lastname
          ?.toLowerCase()
          .includes(searchLower);

        const documentMatch = item.documentId
          ?.toLowerCase()
          .includes(searchLower);

        const descriptionMatch = item.description
          ?.toLowerCase()
          .includes(searchLower);
        // Búsqueda por ID (convertimos ambos a string para comparar)
        // const idMatch = item.talamoChinaconexionRequestsId
        const referenceMatch = item.reference?.toString().includes(searchValue);

        return (
          nameMatch ||
          lastNameMatch ||
          documentMatch ||
          descriptionMatch ||
          referenceMatch
        );
      });

      setRows(resultSearch);
    } else {
      setRows(rowsResponse);
    }
  };

  const RefreshTable = (filterValues = values) => {
    axios
      .get(`${urlServices}payment-link/list-client/${UserAuth.clients_id}`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let filteredData = response.data;

          // Usa filterValues en lugar de values
          if (filterValues.startLink && filterValues.endLink) {
            const fromDate = Moment(filterValues.startLink).format(
              "YYYY-MM-DD",
            );
            const toDate = Moment(filterValues.endLink).format("YYYY-MM-DD");

            filteredData = filteredData.filter((client) => {
              const clientDate = Moment(client.createdAt).format("YYYY-MM-DD");
              return clientDate >= fromDate && clientDate <= toDate;
            });
          }

          let totalPendingValue = 0;

          let dataFinal = filteredData.map((data) => {
            const commissionPercentage = parseFloat(
              data.client?.percentage || 0,
            );
            const payTotal = parseFloat(data.total || 0);

            // Cálculo de la comisión
            const commission = (commissionPercentage * payTotal) / 100;

            // Cálculo del total a transferir (total - comisión)
            const transferAmount = payTotal - commission;

            totalPendingValue += transferAmount;
            return {
              ...data,
              commissionPayment: commission.toFixed(2),
              commissionPaymentTotal: transferAmount.toFixed(2),
            };
          });

          // SALDO DEL DÍA
          const PaidTransactions = dataFinal.filter(
            (val) =>
              val.status === 3 &&
              val.outstandingBalance === 0 &&
              val.transitBalance === 0 &&
              val.adminPayment === 0,
          );

          // SALDO ACUMULADO
          const OutstandingBalance = dataFinal.filter(
            (val) =>
              val.status === 3 &&
              val.outstandingBalance === 1 &&
              val.transitBalance === 0 &&
              val.adminPayment === 0,
          );

          // SALDO DISPONIBLE
          const TransitBalance = dataFinal.filter(
            (val) =>
              val.status === 3 &&
              val.outstandingBalance === 1 &&
              val.transitBalance === 1 &&
              val.adminPayment === 0,
          );

          // Sumar todos los montos de las transacciones pagadas
          const totalBalanceValue = PaidTransactions.reduce(
            (sum, transaction) => {
              // Asegúrate de que transaction.amount es un número (por si acaso)
              const amount = Number(transaction.commissionPaymentTotal) || 0;
              return sum + amount;
            },
            0,
          );

          // Sumar todos los montos de las transacciones pasada de 1 dias
          const totalOutstandingBalanceValue = OutstandingBalance.reduce(
            (sum, transaction) => {
              // Asegúrate de que transaction.amount es un número (por si acaso)
              const amount = Number(transaction.commissionPaymentTotal) || 0;
              return sum + amount;
            },
            0,
          );

          // Sumar todos los montos de las transacciones pasada de 2 dias
          const totalTransitBalanceValue = TransitBalance.reduce(
            (sum, transaction) => {
              // Asegúrate de que transaction.amount es un número (por si acaso)
              const amount = Number(transaction.commissionPaymentTotal) || 0;
              return sum + amount;
            },
            0,
          );

          setTotalBalance(totalBalanceValue);
          setTotalOutstandingBalance(totalOutstandingBalanceValue);
          setTotalTransitBalance(totalTransitBalanceValue);
          setRows(dataFinal);
          setRowsResponse(dataFinal);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  // Agrega este efecto
  useEffect(() => {
    RefreshTable();
  }, [values.startLink, values.endLink]); // Se ejecutará cuando cambien las fechas

  // Manejar cambio de fecha inicial
  const handleDateStartChange = (date) => {
    setDateStart(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    if (dateEnd && dateEnd <= date) {
      setDateEnd(null);
      setValues((prev) => ({ ...prev, endLink: "" }));
    }

    setValues((prev) => ({
      ...prev,
      startLink: formattedDate,
    }));
    setShowStartCalendar(false);
  };

  // Manejar cambio de fecha final
  const handleDateEndChange = (date) => {
    setDateEnd(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    setValues((prev) => ({
      ...prev,
      endLink: formattedDate,
    }));
    setShowEndCalendar(false);
  };

  const changeClientsDeleteFilter = () => {
    // 1. Primero limpia los valores
    const newValues = {
      ...values,
      startLink: null,
      endLink: null,
    };

    setValues(newValues);
    setDateStart(false);
    setDateEnd(false);

    // 2. Luego refresca la tabla con los nuevos valores
    RefreshTable(newValues); // Pasa los nuevos valores explícitamente
  };

  const openStatusValue = (data, status) => () => {
    setIdRow({ id: data.row.id, status: status });
    setOpenStatus(true);
  };

  const openViewValue = (data) => () => {
    setIdRow(data.row);
    setOpenView(true);
  };

  const openRefundValue = (data) => () => {
    setIdRow(data.row);
    setOpenRefund(true);
  };

  const handleCloseNew = () => setOpenNew(false);
  const handleCloseRefund = () => setOpenRefund(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseView = () => setOpenView(false);
  const handleCloseDialogWithdrawPayment = () => setOpenWithdrawPayment(false);
  const handleCloseDialogMessageNotification = () =>
    setOpenMessageNotification(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar({ open: false });
  };

  const handleDetails = (data) => () => {
    setIdRow(data.row);
    setOpenDetails(true);
  };

  const handleWithdrawPaymentValue = (data) => () => {
    setIdRow(data.row);
    setOpenWithdrawPayment(true);
  };

  const handleMessageNotificationValue = (data) => () => {
    setIdRow(data.row.notification ? JSON.parse(data.row.notification) : null);
    setOpenMessageNotification(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const submitWithdrawPayment = async () => {
    try {
      const dataValue = {
        withdrawPayment: 1,
      };

      const response = await axios.put(
        `${urlServices}payment-link/${idRow.id}`,
        dataValue,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        },
      );

      if (response.status === 200) {
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "success",
          mensaje: "Solicitud enviada a la administración",
        });
        RefreshTable();
        setOpenWithdrawPayment(false);
      }
    } catch (error) {}
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid xs={12} sm={12} md={12}>
        <Card
          sx={{ padding: "15px 20px", margin: { xs: "60px 0", sm: "10px 0" } }}
          variant="outlined"
        >
          {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
          {loader ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "20% 0" }}
                  />
                </center>
              </Grid>
            </Grid>
          ) : (
            <Fragment>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <div className={classes.cardTitleBlack}>
                    <List className={classes.iconFilter} /> Links de pagos
                  </div>
                </Grid>
                <Grid item xs={12} sm={2} sx={{ mb: 1 }}></Grid>
                <Grid item xs={12} sm={3.2} sx={{ my: 2 }}>
                  <Typography
                    sx={{
                      color: "text.secondary",
                      mb: 1,
                      fontWeight: "bold",
                      fontSize: 22,
                    }}
                  >
                    Saldo del día
                  </Typography>
                  <Box
                    sx={{
                      fontSize: 26,
                      fontWeight: "bold",
                      borderRadius: 2,
                      p: "10px 15px",
                      background:
                        "linear-gradient(145deg, rgb(229, 246, 253), rgb(229, 246, 253, 0.2))",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      // maxWidth: 200,
                      //margin: '0 auto',
                      // border: '1px solid',
                      // borderColor: 'divider',
                      color: "#1a237e",
                      textAlign: "center",
                      "&:hover": {
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                  >
                    {parseFloat(totalBalance).toFixed(2)}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: 12,
                        marginLeft: 10,
                      }}
                    >
                      USD
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3.2} sx={{ my: 2 }}>
                  <Typography
                    sx={{
                      color: "text.secondary",
                      mb: 1,
                      fontWeight: "bold",
                      fontSize: 22,
                    }}
                  >
                    Acumulado{" "}
                    <span style={{ fontSize: 10 }}>(En transito)</span>
                  </Typography>
                  <Box
                    sx={{
                      fontSize: 26,
                      fontWeight: "bold",
                      borderRadius: 2,
                      p: "10px 15px",
                      background:
                        "linear-gradient(145deg, rgb(255, 244, 229), rgb(229, 246, 253, 0.2))",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      // maxWidth: 200,
                      // margin: '0 auto',
                      //  border: '1px solid',
                      // borderColor: 'divider',
                      color: "rgb(102, 60, 0)",
                      textAlign: "center",
                      "&:hover": {
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                  >
                    {parseFloat(totalOutstandingBalance).toFixed(2)}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: 12,
                        marginLeft: 10,
                      }}
                    >
                      USD
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3.2} sx={{ my: 2 }}>
                  <Typography
                    sx={{
                      color: "text.secondary",
                      mb: 1,
                      fontWeight: "bold",
                      fontSize: 22,
                    }}
                  >
                    Disponible{" "}
                    <span style={{ fontSize: 10 }}>
                      (Disponible a transferirte)
                    </span>
                  </Typography>
                  <Box
                    sx={{
                      fontSize: 26,
                      fontWeight: "bold",
                      borderRadius: 2,
                      p: "10px 15px",
                      background:
                        "linear-gradient(145deg, rgb(237, 247, 237), rgb(30, 70, 32, 0.1))",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      // maxWidth: 200,
                      // margin: '0 auto',
                      //  border: '1px solid',
                      // borderColor: 'divider',
                      color: "rgb(30, 70, 32)",
                      textAlign: "center",
                      "&:hover": {
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                  >
                    {parseFloat(totalTransitBalance).toFixed(2)}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: 12,
                        marginLeft: 10,
                      }}
                    >
                      USD
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Filtro por fecha:
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <ClickAwayListener
                    onClickAway={() => setShowStartCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha inicial"
                        value={dateStart ? format(dateStart, "dd/MM/yyyy") : ""}
                        onClick={() => setShowStartCalendar(!showStartCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        size="small"
                      />
                      {showStartCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateStart}
                            onChange={handleDateStartChange}
                            locale={es}
                            color={blackColor}
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                </Grid>

                <Grid item xs={12} md={3}>
                  <ClickAwayListener
                    onClickAway={() => setShowEndCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha final"
                        value={dateEnd ? format(dateEnd, "dd/MM/yyyy") : ""}
                        onClick={() => setShowEndCalendar(!showEndCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        disabled={!dateStart}
                        size="small"
                      />
                      {showEndCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateEnd}
                            onChange={handleDateEndChange}
                            locale={es}
                            color={blackColor}
                            minDate={
                              dateStart ? addDays(dateStart, 1) : undefined
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                  <b
                    style={{
                      fontSize: 10,
                      color: "red",
                      cursor: "pointer",
                      display: dateStart && dateEnd ? "block" : "none",
                      marginTop: 5,
                    }}
                    onClick={changeClientsDeleteFilter}
                  >
                    <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                  </b>
                </Grid>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4}>
                  {/* Campo de búsqueda */}
                  <Box sx={{ float: "right", width: "100%" }}>
                    <TextField
                      variant="outlined"
                      value={searchText}
                      onChange={handleSearchChange}
                      sx={{ marginBottom: 2, width: "100%" }}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <Search
                            position="start"
                            style={{
                              color: "gray",
                              fontSize: 22,
                              marginRight: 10,
                            }}
                          />
                        ),
                      }}
                      placeholder="Buscar cliente o referencia..."
                      autoComplete="off"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                  <div style={{ float: "right" }}>
                    <ButtonStyle0
                      onClick={(event) => {
                        setOpenNew(true);
                      }}
                      endIcon={<Add />}
                    >
                      Crear link
                    </ButtonStyle0>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 12,
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <DataGrid
                        rows={rows}
                        columns={state.columns}
                        loading={loader}
                        initialState={{
                          pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                          },
                        }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        disableRowSelectionOnClick={true}
                        checkboxSelection={false}
                        rowHeight={140}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            display: "flex",
                            alignItems: "center", // Alineación vertical
                            // justifyContent: 'center', // Alineación horizontal
                            //wordWrap: 'break-word !important',
                            //whiteSpace: 'normal !important',
                          },
                          /* [`& .${gridClasses.columnHeaderTitle}`]: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          },*/
                        }}
                        getRowHeight={() => "auto"}
                        //autoHeights
                        autoWidth
                      />
                    </ThemeProvider>
                  </Box>
                </Grid>
              </Grid>
            </Fragment>
          )}
        </Card>
      </Grid>
      <Snackbar
        open={openSnackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
        >
          {openSnackbar.mensage}
        </Alert>
      </Snackbar>
      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity={alert.errorAlert === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {alert.mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      )}
      {openNew && (
        <NewLinkPaymentsAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openView && (
        <ViewLinkAdmin open={openView} exit={handleCloseView} id={idRow} />
      )}
      {openDetails && (
        <ViewsTrasactionsPayment
          open={openDetails}
          exit={handleCloseDetails}
          id={idRow}
        />
      )}
      {openStatus && (
        <StatusPaymentLinkAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}

      <StatusRefundLinkAdmin
        open={openRefund}
        exit={handleCloseRefund}
        id={idRow}
        callBackRefresh={RefreshTable}
        admin={false}
      />

      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialogWithdrawPayment}
        aria-labelledby="customized-dialog-title"
        open={openWithdrawPayment}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container className={classes.containerProfile}>
            <Grid item xs={12} sm={12}>
              <div className={classes.titleCardFilter}>Retirar pago</div>
              <div className={classes.lineBottom}></div>
              <br></br>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                textAlign: "center",
                p: 0.6,
                m: 1,
                background: "#F6F6F6",
              }}
            >
              <b style={{ fontSize: 12 }}>Valor a cobrar</b>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                textAlign: "center",
                py: 1,
                borderBottom: "1px solid #ccc",
              }}
            >
              <span style={{ fontWeight: 500, fontSize: 14 }}>
                {`SubTotal: $${idRow.description === "PAGO POR API" ? idRow.total : idRow.subTotal}`}
              </span>
            </Grid>
            {idRow.description !== "PAGO POR API" && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  py: 1,
                  borderBottom: "1px solid #ccc",
                }}
              >
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {`${parseFloat(idRow.iva).toFixed(0)}% iva: $${
                    idRow.ivaSubtotal
                  }`}
                </span>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                textAlign: "center",
                py: 1,
                borderBottom: "1px solid #ccc",
              }}
            >
              <span style={{ fontWeight: 500, fontSize: 14, color: "red" }}>
                {`Fee: - $${
                  idRow.commissionPayment ? idRow.commissionPayment : "0.00"
                }`}
              </span>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{ textAlign: "center", py: 1, mt: 2 }}
            >
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {`TOTAL: $${idRow.commissionPaymentTotal}`}
              </span>
              <Alert severity="info" sx={{ textAlign: "left" }}>
                Recibirás tu dinero en la cuenta bancaria en un plazo máximo de
                24 horas.
              </Alert>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ mt: 4 }}>
              <center>
                <ButtonStyle0 type="submit" onClick={submitWithdrawPayment}>
                  Retirar fondos
                </ButtonStyle0>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialogWithdrawPayment}>
            Cerrar
          </ButtonExit>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialogMessageNotification}
        aria-labelledby="customized-dialog-title"
        open={openMessageNotification}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container className={classes.containerProfile}>
            <Grid item xs={12} sm={12}>
              <div className={classes.titleCardFilter}>
                Notificación de la administración de este pago
              </div>
              <div className={classes.lineBottom}></div>
              <br></br>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ my: 3 }}>
              <Box sx={{ p: 2, border: "1px solid #F1F1F1" }}>
                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 14, fontWeight: 500, marginBottom: 2 }}
                >
                  Mensaje: <span style={{ float: "right" }}>{idRow?.date}</span>
                </b>

                <Alert severity="warning" icon={<InsertCommentOutlined />}>
                  {idRow?.message}
                </Alert>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialogMessageNotification}>
            Cerrar
          </ButtonExit>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
